export default __webpack_public_path__ + "static/media/Widetravel.a3c98ede.png";